export default function initPlayerVideo() {
    document.querySelectorAll('.js-player-video').forEach(ele => {
        new PlayerVideo(ele);
    });
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class PlayerVideo {
    constructor($el) {
        this.$el = $el;
        this.$poster = $el.querySelector('.js-poster');
        this.$btnPlay = $el.querySelector('.js-btn-play-video');
        this.init();
    }

    init() {
        this.$btnPlay.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.$poster.classList.add('hidden');
            if (evt.target.dataset.type === 'mp4') {
                this.$el.querySelector('.mejs-play button').click();
            } else {
                this.$el.querySelector('.video iframe').src += '&autoplay=1';
            }
        });
    }
}
